export default __webpack_public_path__ + "static/media/README.46ebffa5.md";